import { useState, useEffect } from "react";
import axios from '../../api/axios';
import { useAuth } from '../../context/AuthProvider';
import { useNavigate, Link } from "react-router-dom";
import './User.css';

const UserProfile = () => {
  const { auth, loading } = useAuth();
  const [formData, setFormData] = useState({ name: "", username: "", email: "", password: "" });
  const [successMessage, setSuccessMessage] = useState("");
  const [errorMessage, setErrorMessage] = useState("");
  const [twoFactorEnabled, setTwoFactorEnabled] = useState(false);
  const [showOTPField, setShowOTPField] = useState(false);
  const [qrCode, setQrCode] = useState("");
  const [secret, setSecret] = useState("");
  const [twoFAType, setTwoFAType] = useState("");
  const [updating, setUpdating] = useState(false);   // Spinner, disables fields/buttons
  const [justUpdated, setJustUpdated] = useState(false); // Lock form for 2s after success

useEffect(() => {
  console.log("📦 Initializing 2FA Type:", twoFAType);

  if (auth.user && twoFAType === "") {
    const initialType = auth.user.twoFactorMethod || (auth.user.email ? "email" : "app");
    setTwoFAType(initialType);
  }
}, [auth.user, twoFAType]);

  
  

  const [pendingVerificationEmail, setPendingVerificationEmail] = useState(null);
  const [verificationCodeDigits, setVerificationCodeDigits] = useState(["", "", "", "", "", ""]);
  
  const handleVerificationDigitChange = (index, value) => {
    if (!/^\d?$/.test(value)) return; // only digits, single char
    const updatedDigits = [...verificationCodeDigits];
    updatedDigits[index] = value;
    setVerificationCodeDigits(updatedDigits);
  
    if (value && index < 5) {
      const nextInput = document.querySelector(`#verify-otp-${index + 1}`);
      if (nextInput) nextInput.focus();
    }
  };
  



  
  
  
  
  const resendVerification = async (email) => {
    try {
      const csrfToken = document.cookie
        .split("; ")
        .find(row => row.startsWith("csrfToken="))
        ?.split("=")[1];
  
      await axios.post("/api/2fa/resend-backup-verification", { email }, {
        headers: { "x-csrf-token": csrfToken },
        withCredentials: true
      });
  
      // 👇 Set this so the OTP field shows up
      setPendingVerificationEmail(email);
      setVerificationCodeDigits(["", "", "", "", "", ""]);
  
      alert("Verification code has been resent.");
    } catch (err) {
      console.error("❌ Resend failed:", err);
      alert("Failed to resend verification code.");
    }
  };
  


  const [otpDigits, setOtpDigits] = useState(["", "", "", "", "", ""]);
  const otp = otpDigits.join(""); // Combine for backend submission


  const [confirmPassword, setConfirmPassword] = useState(""); // ✅ New state


  const [password, setPassword] = useState("");
  const [showBackupRegeneration, setShowBackupRegeneration] = useState(false);

  const [disable2FAPassword, setDisable2FAPassword] = useState("");
  const [showDisable2FAPasswordField, setShowDisable2FAPasswordField] = useState(false);



  const navigate = useNavigate();

  useEffect(() => {
    if (auth.user) {
      //console.log("🔍 Auth User Data in UserProfile:", auth.user);
      
      setFormData({ 
        name: auth.user.name, 
        username: auth.user.username || "", 
        email: auth.user.email, 
        password: "" 
      });
      setTwoFactorEnabled(auth.user.twofactorRequired); // ✅ Correctly check if 2FA is enabled
      setTwoFAType(auth.user.twoFactorMethod || "email"); // ✅ Set 2FA type from auth
    }
  }, [auth.user]);

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

const handleSubmit = async (e) => {
  e.preventDefault();
  setSuccessMessage("");
  setErrorMessage("");

  if (formData.password && formData.password !== confirmPassword) {
    setErrorMessage("Passwords do not match.");
    return;
  }

  setUpdating(true);

  try {
    const csrfToken = document.cookie
      .split("; ")
      .find(row => row.startsWith("csrfToken="))
      ?.split("=")[1];

    if (!csrfToken) {
      setUpdating(false);
      setErrorMessage("Failed to update profile due to security validation.");
      return;
    }

    await axios.put("/api/user/me", formData, {
      withCredentials: true,
      headers: { "x-csrf-token": csrfToken }
    });

    setSuccessMessage("Profile updated successfully! ✅");
    setJustUpdated(true);

    // Optionally: Refetch user/auth context here (instead of reload)
    setTimeout(() => {
      setJustUpdated(false);
      setSuccessMessage("");
      setUpdating(false);
      // Optionally, reload here if you absolutely need to refresh JWT/user data:
      // window.location.reload();
    }, 2000);

  } catch (error) {
    setUpdating(false);
    setErrorMessage(error.response?.data?.error || "Update failed.");
  }
};

  


  const enable2FA = async () => {
    try {
        // ✅ Retrieve CSRF token from cookies
        const csrfToken = document.cookie
            .split("; ")
            .find(row => row.startsWith("csrfToken="))
            ?.split("=")[1];

        if (!csrfToken) {
            console.error("🚨 Missing CSRF token. Request blocked.");
            setErrorMessage("Failed to enable 2FA due to security validation.");
            return;
        }

        let res;
        if (twoFAType === "email") {
            res = await axios.post("/api/2fa/send-2fa-email", {}, {
                withCredentials: true,
                headers: { "x-csrf-token": csrfToken }
            });
        } else {
            // ✅ Send email along with the request
            res = await axios.post("/api/2fa/enable-2fa", { email: formData.email }, {
                withCredentials: true,
                headers: { "x-csrf-token": csrfToken }
            });
        }

        setQrCode(res.data.qrCode);
        setSecret(res.data.secret);
        setShowOTPField(true);
    } catch (error) {
        setErrorMessage(error.response?.data?.error || "Failed to enable 2FA.");
    }
};

const handleOtpChange = (value, index) => {
  if (!/^\d?$/.test(value)) return;
  const updatedDigits = [...otpDigits];
  updatedDigits[index] = value;
  setOtpDigits(updatedDigits);

  if (value && index < 5) {
    document.getElementById(`otp-${index + 1}`).focus();
  }
};

const handleOtpPaste = (e) => {
  e.preventDefault();
  const pasteData = e.clipboardData.getData('text').replace(/\D/g, '').slice(0, 6);

  if (pasteData.length === 6) {
    const updatedDigits = pasteData.split('');
    setOtpDigits(updatedDigits);
    document.getElementById('otp-5').focus();
  }
};


const handleGenericOtpPaste = (e, setDigits, prefix) => {
  e.preventDefault();
  const pasteData = e.clipboardData.getData("text").replace(/\D/g, "").slice(0, 6);

  if (pasteData.length === 6) {
    const updatedDigits = pasteData.split("");
    setDigits(updatedDigits);

    // Delay focus to allow state update
    setTimeout(() => {
      const lastInput = document.getElementById(`${prefix}-5`);
      if (lastInput) lastInput.focus();
    }, 0);
  }
};


const handleOtpKeyDown = (e, index) => {
  if (e.key === "Backspace" && !otpDigits[index] && index > 0) {
    const updatedDigits = [...otpDigits];
    updatedDigits[index - 1] = "";
    setOtpDigits(updatedDigits);
    document.getElementById(`otp-${index - 1}`).focus();
  }
};


const verifyOTP = async () => {
  try {
      const csrfToken = document.cookie
          .split("; ")
          .find(row => row.startsWith("csrfToken="))
          ?.split("=")[1];

      if (!csrfToken) {
          console.error("🚨 Missing CSRF token. Request blocked.");
          setErrorMessage("Failed to verify 2FA due to security validation.");
          return;
      }

      const endpoint = twoFAType === "email" 
          ? "/api/2fa/verify-email-2fa" 
          : "/api/2fa/verify-2fa";

      const res = await axios.post(endpoint, { otp }, {
          withCredentials: true,
          headers: { "x-csrf-token": csrfToken }
      });

      setShowOTPField(false);
      setSuccessMessage("Two-Factor Authentication enabled successfully!");

      if (twoFAType === "app") {
          navigate("/admin/backup-codes", {
              state: { backupCodes: res.data.backupCodes }
          });
      } else {
          setTimeout(() => window.location.reload(), 500);
      }
  } catch (error) {
      setErrorMessage(error.response?.data?.error || "Invalid OTP.");
  }
};


const regenerateBackupCodes = async () => {
  setErrorMessage("");
  setSuccessMessage("");

  try {
    const csrfToken = document.cookie
      .split("; ")
      .find(row => row.startsWith("csrfToken="))
      ?.split("=")[1];

    if (!csrfToken) {
      setErrorMessage("Failed to regenerate backup codes due to security validation.");
      return;
    }

    const res = await axios.post(
      "/api/2fa/regenerate-backup-codes",
      { password },
      {
        withCredentials: true,
        headers: { "x-csrf-token": csrfToken },
      }
    );

    if (res.data.backupCodes) {
      navigate("/admin/backup-codes", { state: { backupCodes: res.data.backupCodes } }); // ✅ Pass codes here
    }
  } catch (error) {
    setErrorMessage(error.response?.data?.error || "Failed to regenerate backup codes.");
  }
};



  

const disable2FA = async () => {
  try {
      if (!disable2FAPassword) {
          setErrorMessage("Password is required to disable 2FA.");
          return;
      }

      const csrfToken = document.cookie
          .split("; ")
          .find(row => row.startsWith("csrfToken="))
          ?.split("=")[1];

      if (!csrfToken) {
          console.error("🚨 Missing CSRF token. Request blocked.");
          setErrorMessage("Failed to disable 2FA due to security validation.");
          return;
      }

      await axios.post("/api/2fa/disable-2fa", { password: disable2FAPassword }, {
          withCredentials: true,
          headers: { "x-csrf-token": csrfToken }
      });

      setSuccessMessage("Two-Factor Authentication disabled.");
      setTimeout(() => window.location.reload(), 500);
  } catch (error) {
      setErrorMessage(error.response?.data?.error || "Failed to disable 2FA.");
  }
};


if (loading) {
  return (
    <div className="user-profile">
      <div className="spinner"></div>
      <p>Loading your profile...</p>
    </div>
  );
}


  return (
    <>

      <>
      


        {successMessage && <p className="success" aria-live="polite">{successMessage}</p>}
        {errorMessage && <p className="error" aria-live="polite">{errorMessage}</p>}

        {/* ✅ Profile Update Form */}
        
        <form onSubmit={handleSubmit} className="update-profile-form">
          <h3>Update Profile</h3>
          <label htmlFor="profile-name">Name</label>
          <input 
            id="profile-name"
            type="text" 
            name="name" 
            value={formData.name} 
            onChange={handleChange} 
            placeholder="Name"
            disabled={updating || justUpdated}
            required 
          />

          <label htmlFor="profile-username">Username</label>
          <input 
            id="profile-username"
            type="text" 
            name="username" 
            value={formData.username} 
            onChange={handleChange} 
            placeholder="Username" 
            disabled={updating || justUpdated}
            required 
          />


          <label htmlFor="profile-email">Email</label>
          <input 
            id="profile-email"
            type="email" 
            name="email" 
            value={formData.email} 
            onChange={handleChange} 
            placeholder="Email" 
            disabled={updating || justUpdated}
            required 
          />

          <label htmlFor="new-password">New Password (optional)</label>
          <input
            id="new-password"
            type="password"
            name="password"
            placeholder="New Password (optional)"
            disabled={updating || justUpdated}
            onChange={handleChange}
          />

          <label htmlFor="confirm-password">Confirm New Password (optional)</label>
          <input
            id="confirm-password"
            type="password"
            placeholder="Confirm New Password (optional)"
            onChange={(e) => setConfirmPassword(e.target.value)}
            disabled={updating || justUpdated}
          />

          <button
            type="submit"
            className="submit-profile-update"
            disabled={updating || justUpdated}
          >
            {updating
              ? <div className="spinner"></div>
              : "Update Profile"}
          </button>
        </form>
      </>

    </>
  );
};

export default UserProfile;